import { getEnvRuntimeVariable } from '@if/core/utils'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

let ai: ApplicationInsights | null = null

export function initializeAppInsights(): ApplicationInsights {
  ai = new ApplicationInsights({
    config: {
      instrumentationKey: getEnvRuntimeVariable(import.meta.env.VITE_APP_APP_INSIGHT_INSTRUMENTAL_KEY),
      disableAjaxTracking: true,
      disableFetchTracking: true,
      disableCorrelationHeaders: true,
      autoTrackPageVisitTime: false,
    },
  })

  ai.loadAppInsights()
  ai.addTelemetryInitializer((envelope) => {
    if (envelope.baseType === 'PageviewData' || envelope.baseType === 'PageviewPerformanceData') {
      return false
    }
    return true
  })
  return ai
}
